import { useCallback } from 'react';
import { getFields } from 'src/azure/services/work-items';
import { findAllFieldTypesByWorkItemField } from '../../../utils/find-all-fields-types-by-wi-field';

export function useWorkItemFieldHook() {
	const getWorkItemFieldOptions = useCallback(async (args: {
    projectId: string;
  }) => {
		const fields = await getFields(args.projectId);
		if (fields) {
			const foundFields = fields.filter(field => field.referenceName !== 'System.TeamProject');
			return findAllFieldTypesByWorkItemField(foundFields)
				.map(item => ({ label: item.name, value: item.referenceName }));
		}

		return [];
	}, []);

	return {
		getWorkItemFieldOptions,
	};
}